export default __webpack_public_path__ + "static/media/mongodbVSFirebase.7976f27d.md";